// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__IXBR_","title":"AfterBackImages_title__1Sdzn","images":"AfterBackImages_images__2n-Tq"};